import { Brands, Environments } from '@delta-defense/client-environments';

const enum Methods {
  Uscca = 'USCCA',
  Cabelas = 'Cabelas'
}

const BrandMethodsDictionary: Record<Brands, Methods> = {
  [Brands.USCCA]: Methods.Uscca,
  [Brands.CabelasShield]: Methods.Cabelas
};

export const getLoginMethod = (
  brand = Environments.getDomainBrand()
): Methods =>
  BrandMethodsDictionary[brand];
